import React from 'react';
import { graphql } from 'gatsby';
import GenericError from '../components/ShoppingCart/GenericError';
import {
  openLinkInNewTab,
  flattenNodes,
  getErrorMessage,
  getErrorMessageFromQueryParam
} from '../helpers/common';
import { ERROR_CODES } from '../types/common.types';
import { useDispatch } from 'react-redux';
import useTranslate from '../hooks/useTranslation';
import { ACTION_TYPES as SHOP_ACTION_TYPES } from '../constants/actions';
import CONSTANTS from '../constants/common';
import LINKS from '../config/links';

export const Error = ({ data, location }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const allErrorMessagesFlattened = flattenNodes(data.allErrorMessage);

  const errorMessageFromQueryParam = getErrorMessageFromQueryParam({
    location,
    paramKey: CONSTANTS.URL_PARAMS.ERROR,
    errorData: allErrorMessagesFlattened
  });
  const genericErrorMessage = getErrorMessage(
    ERROR_CODES.GENERIC,
    allErrorMessagesFlattened
  );

  if (!genericErrorMessage) return null;
  const errorProps = {
    title: errorMessageFromQueryParam?.title || t('EKYC_GENERIC_ERROR_TITLE'),
    errorText:
      errorMessageFromQueryParam?.description ||
      t('EKYC_GENERIC_ERROR_MESSAGE'),
    primaryButtonText: t('CHAT_ON_WHATSAPP'),
    secondaryButtonText: t('EFORM_REQUEST'),
    onPrimaryClick: () => {
      dispatch({ type: SHOP_ACTION_TYPES.PAYMENT.CLEAR_BUY_FLOW_DATA });
      dispatch({ type: 'CLEAR_CHECKOUT_ERROR' });
      openLinkInNewTab(LINKS.whatsAppChatLink);
    },
    onSecondaryClick: () => {
      openLinkInNewTab(LINKS.online_eform_link);
    }
  };

  return <GenericError {...errorProps} />;
};

export const query = graphql`
  query ErrorQuery {
    allErrorMessage {
      edges {
        node {
          ...AemComponentsFragment
        }
      }
    }
  }
`;

export default Error;
